import { useState } from "react";
import { useTheme } from "../../utils/themeToggle/theme";

export const ReplyOutlineIcon = () => {
    const { darkMode } = useTheme();
    const [isHovered, setIsHovered] = useState(false);

    const color = darkMode ? "#fff" : "#1F2937"; // white in dark mode, black in light
    const hoverColor = "#a395da"; // optional hover color

    return (
        <svg
            style={{
                fontSize: "24px",
                color: isHovered ? hoverColor : color,
                cursor: "pointer",
                transition: "transform 0.3s ease, color 0.3s ease",
                transform: isHovered ? "translateX(-8px)" : "translateX(0)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill={isHovered ? hoverColor : color} // fill dynamically
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4394 0.101692C10.7824 0.269496 11 0.618074 11 1.00001V4.00331C11.3528 4.0078 11.6289 4.0184 11.8822 4.04334C16.1551 4.4642 19.5358 7.84486 19.9567 12.1179C20 12.5584 20 13.0678 20 13.9299V15C20 15.4045 19.7564 15.7691 19.3827 15.9239C19.009 16.0787 18.5789 15.9931 18.2929 15.7071L17.8284 15.2426C16.627 14.0412 16.1204 13.5411 15.555 13.1662C14.8025 12.6672 13.9607 12.3185 13.0759 12.1393C12.5592 12.0347 12.0143 12.0085 11 12.0021V15C11 15.3819 10.7824 15.7305 10.4394 15.8983C10.0963 16.0661 9.68754 16.0238 9.38606 15.7894L0.386059 8.78936C0.142473 8.5999 0 8.3086 0 8.00001C0 7.69142 0.142473 7.40011 0.386059 7.21066L9.38606 0.210655C9.68754 -0.0238291 10.0963 -0.0661107 10.4394 0.101692ZM2.62882 8.00001L9 12.9554V10H10C10.0392 10 10.078 10 10.1165 10C11.6645 9.99989 12.5877 9.99983 13.4729 10.1791C14.6106 10.4095 15.6929 10.8579 16.6603 11.4994C17.1002 11.7911 17.5059 12.1352 17.9856 12.5894C17.9809 12.4875 17.9746 12.3983 17.9663 12.3139C17.639 8.99045 15.0096 6.36104 11.6861 6.03371C11.3562 6.00122 10.9525 6.00001 10 6.00001H9V3.04465L2.62882 8.00001Z"
            />
        </svg>
    );
};

export const ReplyAllOutlineIcon = ({ size = 24 }) => {
    const { darkMode } = useTheme();
    const [isHovered, setIsHovered] = useState(false);

    const color = darkMode ? "#fff" : "#1F2937";
    const hoverColor = "#a395da";

    return (
        <svg
            style={{
                fontSize: size,
                color: isHovered ? hoverColor : color,
                cursor: "pointer",
                transition: "transform 0.3s ease, color 0.3s ease",
                transform: isHovered ? "translateX(-5px)" : "translateX(0)",
            }}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={isHovered ? hoverColor : color} // dynamic stroke
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="reply-all-icon"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <polyline points="7 17 2 12 7 7" />
            <polyline points="12 17 7 12 12 7" />
            <path d="M22 18v-2a4 4 0 0 0-4-4H7" />
        </svg>
    );
};
